export default __webpack_public_path__ + "static/media/ju3.895b9bd8.jpg";